interface KaraokeNoticeProps {
  lang: 'en' | 'ja';
}

export default function KaraokeNotice({ lang }: KaraokeNoticeProps) {
  const content = {
    en: {
      badge: 'Important Notice',
      title: 'Please Read Before Booking',
      notices: [
        {
          icon: 'ri-money-yen-circle-line',
          title: 'Room & Food/Drink Fees',
          description: 'The karaoke room fee and any food or drinks you order are paid directly to the venue. Our service fee covers guidance and support only.'
        },
        {
          icon: 'ri-beer-line',
          title: 'Alcohol Service',
          description: 'Alcoholic beverages are provided by the karaoke venue, not by us. Please drink responsibly and follow venue rules.'
        },
        {
          icon: 'ri-car-line',
          title: 'Not a Transportation Service',
          description: 'This is a karaoke experience service, not a transportation or ride service. We meet you at the venue or nearby location.'
        }
      ]
    },
    ja: {
      badge: '重要なお知らせ',
      title: 'ご予約前に必ずお読みください',
      notices: [
        {
          icon: 'ri-money-yen-circle-line',
          title: '部屋代および飲食代',
          description: 'カラオケルームの料金と注文した飲食物の代金は、店舗へ直接お支払いください。当サービスの料金はガイドとサポートのみです。'
        },
        {
          icon: 'ri-beer-line',
          title: '酒類の提供',
          description: 'アルコール飲料はカラオケ店舗が提供するもので、当サービスが提供するものではありません。責任を持って飲酒し、店舗のルールに従ってください。'
        },
        {
          icon: 'ri-car-line',
          title: '運送業ではありません',
          description: 'これはカラオケ体験サービスであり、運送やライドサービスではありません。会場または近くの場所でお会いします。'
        }
      ]
    }
  };

  const t = content[lang];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-amber-50">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 rounded-full mb-6">
            <i className="ri-alert-line text-amber-600"></i>
            <span className="text-amber-700 text-sm font-semibold tracking-wide uppercase">{t.badge}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            {t.title}
          </h2>
        </div>

        {/* Notices */}
        <div className="space-y-6">
          {t.notices.map((notice, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-amber-500 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center">
                  <i className={`${notice.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {notice.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {notice.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-8 text-center">
          <i className="ri-customer-service-2-line text-4xl text-purple-600 mb-4"></i>
          <p className="text-gray-700 text-lg leading-relaxed">
            {lang === 'en' 
              ? 'If you have any questions or concerns, please feel free to contact us via WhatsApp before booking.'
              : 'ご質問や不明な点がございましたら、ご予約前にWhatsAppでお気軽にお問い合わせください。'
            }
          </p>
        </div>
      </div>
    </section>
  );
}